import { render, staticRenderFns } from "./BuyerCallLogs.vue?vue&type=template&id=8659da2e&scoped=true"
import script from "./BuyerCallLogs.vue?vue&type=script&lang=js"
export * from "./BuyerCallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8659da2e",
  null
  
)

export default component.exports